import { useEffect } from 'react';

import playerService from '../lessonPlayer/services/PlayerService';

const useWirisParser = (ref) => {
  useEffect(() => {
    // render math if applicable
    if (!ref || !ref.current) {
      return;
    }
    // Print lesson mode should not convert MathML into Wiris images.
    if (playerService.isPrintPreviewMode()) {
      return;
    }
    if (window.com && window.com.wiris.js.JsPluginViewer) {
      window.com.wiris.js.JsPluginViewer.parseElement(ref.current, true);
    }
  });
};

export default useWirisParser;
